export enum OpleidingCardEnum {
  DEFAULT = 'DEFAULT',
  SELECTOR = 'SELECTOR',
  NONE = 'NONE'
}
